/* import __COLOCATED_TEMPLATE__ from './prism-checkbox-input.hbs'; */
import Component from '@ember/component';

/**
 * @class PrismCheckboxInput
 */
export default Component.extend({
  classNames: ['prism-checkbox'],
  /**
   * Value of the checkbox input.
   *
   * @argument checked
   * @type {Boolean}
   */
  checked: false,
  /**
   * Controls disabled state of the checkbox input.
   *
   * @argument disabled
   * @type {Boolean}
   */
  disabled: false,
  /**
   * Name for the checkbox input.
   *
   * @argument name
   * @type {String}
   */
  name: null,
  /**
   * ID for the checkbox input. Required.
   *
   * @argument inputId
   * @type {String}
   */
  inputId: null,
  /**
   * Class to apply to the checkbox input.
   *
   * @argument inputClass
   * @type {String}
   */
  inputClass: '',
  /**
   * Label to apply to the checkbox input.
   *
   * @argument label
   * @type {String}
   */
  label: null,
  /**
   * ID for the label if present. Required if a label is present.
   *
   * @argument labelId
   * @type {String}
   */
  labelId: null,
  /**
   * Class to apply to the checkbox input label.
   *
   * @argument labelClass
   * @type {String}
   */
  labelClass: '',
  /**
   * Action called when the checkbox is clicked. It is passed the event fired
   *
   * @argument onClick
   * @type {action}
   */
  onClick() {},
  /**
   * Action called when the value of the checkbox changes.
   *
   * @argument onChange
   * @type {action}
   */
  onChange() {},
  _change(event) {
    this.set('checked', event.target.checked);
    this.onChange(event.target.checked);
  }
});